export const getCookies = () => {
    const currentCookies = document.cookie;
    let cookies = {};
    currentCookies.split(';').forEach((item) => {
        const [key, value] = item.split('=');
        cookies = { ...cookies, [key.replace(' ', '')]: value };
    });
    return cookies;
};

export const getToken = () => {
    const token = atob(decodeURIComponent(getCookies()['rappi.id']));
    return JSON.parse(token)['access_token'];
};
